import { FavoritesContext } from '../contexts/FavoritesContext';
import { useContext } from 'preact/hooks';

export default function Views({ view, setView, filters, setFilters }) {
	const { favorites } = useContext(FavoritesContext);

	const handleViewFavorites = () => {
		if (filters.favorites === null) {
			setFilters(prev => ({
				...prev,
				favorites: favorites
			}));
		} else {
			setFilters(prev => ({
				...prev,
				favorites: null
			}));
		}
	};

	return (
		<div class="flex flex-col gap-y-5 md:flex-row md:gap-x-10">
			<div>
				<p class="font-display font-bold mb-2 text-sm">Sortér etter</p>
				<label class="relative block">
					<select
						class="appearance-none w-full text-base bg-light-gray border-2 border-light-gray rounded-lg h-11 pl-3.5 pr-11 hover:bg-gray hover:border-gray focus:outline-none focus:border-gray cursor-pointer"
						onChange={e => {
							setFilters(prev => ({
								...prev,
								ordering: e.target.value
							}));
						}}
					>
						<option value="DATE-DESC">
							Publisert (Nyest - Eldst)
						</option>
						<option value="DATE-ASC">
							Publisert (Eldst - Nyest)
						</option>
						<option value="TITLE-ASC">Alfabetisk (A - Å)</option>
						<option value="TITLE-DESC">Alfabetisk (Å – A)</option>
						<option value="REVENUE-ASC">
							Omseting (Lav - Høy)
						</option>
						<option value="REVENUE-DESC">
							Omseting (Høy - Lav)
						</option>
					</select>
					<i class="far fa-chevron-down absolute top-1/2 right-4 transform -translate-y-1/2 pointer-events-none"></i>
				</label>
			</div>

			<div>
				<p class="font-display font-bold mb-2 text-sm">Visning</p>
				<div class="flex flex-wrap gap-2">
					<button
						class={`h-11 text-base rounded-lg px-4 focus:outline-none ${
							view === 'gallery'
								? 'bg-dark text-white'
								: 'bg-light-gray hover:bg-gray'
						}`}
						onClick={() => setView('gallery')}
					>
						<i class="far fa-th mr-3"></i>
						Rutenett
					</button>
					<button
						class={`h-11 text-base border-2 rounded-lg px-4 focus:outline-none ${
							view === 'list'
								? 'bg-dark border-dark text-white'
								: 'bg-light-gray border-light-gray hover:bg-gray hover:border-gray focus:border-gray'
						}`}
						onClick={() => setView('list')}
					>
						<i class="far fa-list mr-3"></i>
						Liste
					</button>
					<button
						class={`h-11 text-base border-2 rounded-lg px-4 focus:outline-none ${
							view === 'contact'
								? 'bg-dark border-dark text-white'
								: 'bg-light-gray border-light-gray hover:bg-gray hover:border-gray focus:border-gray'
						}`}
						onClick={() => setView('contact')}
					>
						<i class="far fa-user mr-3"></i>
						Kontaktinformasjon
					</button>
					<label class="app-checkbox-label flex gap-x-2 items-center text-sm w-full mt-1 sm:mt-0 sm:w-auto sm:ml-3">
						<input
							type="checkbox"
							class="appearance-none bg-white w-5 h-5 border border-dark rounded bg-center bg-no-repeat flex-shrink-0"
							onClick={e => {
								e.stopPropagation();
								handleViewFavorites();
							}}
							checked={filters.favorites !== null}
						></input>
						<span>
							Vis kun favoritter
							<i class="fas fa-heart ml-1.5 mt-1"></i>
						</span>
					</label>
				</div>
			</div>
		</div>
	);
}
